<template>
	<div class="rule-set main-content-padding" v-loading="loading">
		<Panel :contentPaddingTop="12">
			<BreadCrumb slot="header"></BreadCrumb>
			<div class="width-100 main-box mt-20">
				<div class="font-h3-medium mb-16">请选择达人跟进类型</div>
				<div class="flex-row main-content">
					<div class="left">
						<RdPureCheckGroup @changeTab="handleChangeFollowTab" valueKey="value" v-model="many_partner"
							:data="followTypeList">
							<template slot-scope="{ active, item }">
								<div class="font-h4-medium flex-row-align-center follow-item" :class="{ attribution_tab_active: active }">
									<i v-if="active" class="i-select-corner"></i>
									<i :class="active ? item.activeIcon : item.icon" class="ml-24"></i>
									<span class="ml-8 flow-text" :class="{
										active: active,
									}">
										{{ item.label }}
									</span>
									<span class="yx-color-primary example" @click.stop="handleShowExample(item.value)">示例</span>
								</div>
							</template>
						</RdPureCheckGroup>
					</div>
					<div class="right">
						<div class="rule-item flex-row">
							<div class="rule-title">
								达人运营业绩归属
								<span class="rule-explain" @click="showRuleExplainDialog(2)">《规则说明》</span>
							</div>
							<div class="rule-content">
								<RdPureCheckGroup @changeTab="handleChangeBelongTab" valueKey="value" v-model="results_attribution"
									:data="belongTypeList">
									<template slot-scope="{ active, item }">
										<div class="attribution_tab font-h4-medium" :class="{ attribution_tab_active: active }">
											<i v-if="active" class="i-ruleSet-attributionTab1-active"></i>
											<i v-else class="i-ruleSet-attributionTab1"></i>
											<span class="ml-8">{{ item.label }}</span>
										</div>
									</template>
								</RdPureCheckGroup>
								<div class="setting_bg mt-10" v-if="!isLink">
									<span class="ml-16 font-h4-regular">业绩归属开始时间</span>
									<i class="ml-8" style="color: #c8c9cc"></i>
									<el-select size="mini" v-model="valid_type" placeholder="请选择">
										<el-option v-for="item in getTimeOptions()" :key="item.value" :label="item.label"
											:value="item.value"></el-option>
									</el-select>
									<div style="margin-left: 42px" class="mt-12" v-if="showTimeSelect">
										<span class="font-h4-regular mr-8">订单付款时间</span>
										<el-select size="mini" v-model="valid_time_value" placeholder="请选择">
											<el-option v-for="item in orderPayOptList" :key="item.value" :label="item.label"
												:value="item.value"></el-option>
										</el-select>
									</div>
								</div>
								<div class="content mt-16" v-if="isSinleFollow && !task_status && talentList.length">
									<div class="fz-14">
										共计
										<span class="yx-color-primary">{{ talentList.length }}</span>
										个达人有多个{{ drName }}跟进，重新确认达人与{{ drName }}1对1跟进关系后，其余{{ drName }}关于该达人的合作进度将由最终跟进{{
											drName
										}}继承
									</div>
									<el-table :data="talentList" style="width: 800px!important;" border header-row-class-name="table-header-row" row-class-name="table-row"
										:cell-class-name="cellName" :span-method="arraySpanMethod" :header-cell-class-name="headerCellName"
										class="mt-16">
										<el-table-column label="达人信息">
											<template v-slot="{ row }">
												<div class="talent-info">
													<yx-avatar :size="40" :src="row.head" />
													<div class="right">
														<div class="flex flex-align-center">
															<platform-icon :platformId="row.platform_id" class="platform"></platform-icon>
															<div class="ellipsis ml-4">{{ row.anchor_name }}</div>
														</div>
														<div class="mt-4">ID：{{ row.anchor_id }}</div>
														<div>粉丝数 {{ row.fans_num }}</div>
													</div>
												</div>
												<div class="error fz-12" v-if="row.checked">
													<i class="el-icon-warning mr-8"></i>
													请选择{{ drName }}
												</div>
											</template>
										</el-table-column>
										<el-table-column :label="drName">
											<template v-slot="{ row }">
												<div
													:class="['partners', 'flex', !index ? 'top' : index + 1 === row.partners.length ? 'bottom' : 'middle']"
													v-for="(item, index) in row.partners" :key="index">
													<p>{{ item.partner_role_name }}</p>
													<label class="el-radio label-radio">
														<input type="radio" value="checked" @change="radioFun(row.partners, index)"
															:name="row.anchor_id" v-model="item.checked" />
														<span class="el-radio__label">设为最终跟进人</span>
													</label>
												</div>
											</template>
										</el-table-column>
										<el-table-column label="操作" width="200"></el-table-column>
										<template v-slot:empty v-if="true">
											<div class="empty mt-10 mb-20">
												<img src="@/assets/public/no-data-icon.png" alt="" />
												<p class="yx-color-text-secondary">暂无更正数据…</p>
											</div>
										</template>
									</el-table>
								</div>
							</div>
						</div>
						<div class="rule-item flex-row mt-24" v-if="isSinleFollow">
							<div class="rule-title">
								达人自动流转规则
								<span class="rule-explain" @click="showRuleExplainDialog(3)">《规则说明》</span>
							</div>
							<div class="rule-content">
								<el-switch v-model="anchor_circulation_config" :active-value="1" :inactive-value="0" />
								<div class="content mt-16" v-show="anchor_circulation_config">
									<el-table :data="anchor_circulation_list" header-row-class-name="table-header-row"
										row-class-name="table-row">
										<el-table-column label="适用达人" min-width="250">
											<template v-slot="{ row }">
												<span>{{ ruleData[row.key].name }}</span>
											</template>
										</el-table-column>
										<el-table-column label="规则内容" min-width="250">
											<template v-slot="{ row }">
												<div class="day-input">
													{{ ruleData[row.key].first }}
													<el-input v-model.trim="row.day" :disabled="row.value == 0" placeholder="请输入" />
													{{ ruleData[row.key].last }}
												</div>
											</template>
										</el-table-column>
										<el-table-column label="状态" min-width="100">
											<template v-slot="{ row }">
												<div class="flag" :class="row.value == '1' ? 'open' : 'close'">{{ row.value == '1' ? '已' : '未'
												}}开启</div>
											</template>
										</el-table-column>
										<el-table-column label="操作" min-width="90" align="right">
											<template v-slot="{ row }">
												<el-switch @change="switchChange(row)" v-model="row.value" active-value="1" inactive-value="0" />
											</template>
										</el-table-column>
									</el-table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="bottom-btn">
				<el-button plain @click="cancel">取消</el-button>
				<el-button type="primary" @click="showSaveDialog" :disabled="!!task_status">保存</el-button>
			</div>
		</Panel>
		<rule-explain-dialog ref="ruleExplainDialog" />
		<cancel-dialog ref="cancelDialog" @back="back" />
		<save-dialog ref="saveDialog" @save="save"></save-dialog>
		<Example ref="example" :followTypeList="followTypeList" />
	</div>
</template>

<script>
import { mapState } from 'vuex';
import throttle from 'lodash/throttle';
import ruleExplainDialog from '../components/ruleExplainDialog';
import Example from './components/example';

import cancelDialog from './components/cancelDialog';
import saveDialog from './components/saveDialog';
import { PLATFORM_KS, drRoleType } from '@/utils/dataMap';
import {
	drBelongTypesPlatMap,
	timeSinceOptionMap,
	orderPayOptMap,
	orderPayOptList,
	drBelongTypeMap,
	startTimeMap,
} from '@/utils/newDataMap/settings.js';
import { ruleData } from '../js/data';
import { getWaitFix, getPartnerToAnchor, setPartnerToAnchor } from '@/api/talentCRM';

export default {
	name: 'ruleSet',
	components: {
		ruleExplainDialog,
		cancelDialog,
		saveDialog,
		Example,
	},
	data() {
		return {
			orderPayOptList,
			ruleData,
			task_status: '',
			results_attribution: '',
			anchor_circulation_config: 0,
			anchor_circulation_list: [],
			talentList: [],
			followTypeList: [
				{
					label: '单人跟进',
					value: 0,
					icon: 'i-single-follow',
					activeIcon: 'i-single-follow-active',
				},
				{
					label: '多人跟进',
					value: 1,
					icon: 'i-many-follow',
					activeIcon: 'i-many-follow-active',
				},
			],
			platformId: 1,
			ruleType: 0,
			loading: true,
			many_partner: 0, // 0一对一，1一对多
			valid_time_value: orderPayOptMap.TWO, // 订单付款时间
			valid_type: startTimeMap.SOME, // 业绩归属开始时间
		};
	},
	created() {
		this.platformId = this.$route.query.platformId;
		this.ruleType = this.$route.query.ruleType;
		this.getPartnerToAnchor();
	},
	computed: {
		...mapState(['vuex_userInfo']),
		isSinleFollow() {
			return this.many_partner == 0;
		},
		showTimeSelect({ valid_type }) {
			return startTimeMap.SOME == valid_type;
		},
		isLink() {
			return this.results_attribution == drBelongTypeMap.LINK;
		},
		belongTypeList() {
			const fn = drBelongTypesPlatMap[this.platformId];
			return fn(this);
		},
		isKsPlatform() {
			const { platformId } = this;
			return platformId == +PLATFORM_KS.value;
		},
		drName() {
			return drRoleType.name;
		},
	},
	methods: {
		getTimeOptions() {
			const { results_attribution } = this;
			return timeSinceOptionMap[results_attribution](this);
		},
		handleChangeBelongTab() {
			this.valid_type = this.getTimeOptions()?.[0]?.value;
		},
		handleChangeFollowTab() {
			this.valid_type = this.getTimeOptions()?.[0]?.value;
			this.results_attribution = this.belongTypeList[0]?.value;
			console.log('handleChangeTab', this.many_partner);
		},
		handleShowExample(key) {
			this.$refs['example'].show(key, this.platformId);
		},
		showSaveDialog() {
			if (this.ruleType != 1) return this.$refs.saveDialog.show();
			this.save();
		},
		async getPartnerToAnchor() {
			try {
				const { platformId } = this;
				const {
					code,
					data: {
						anchor_circulation_config = 0,
						anchor_circulation_list = [],
						many_partner,
						task_status = 1,
						results_attribution,
						valid_time,
						valid_type,
					} = {},
				} = await getPartnerToAnchor({ platform_id: platformId });
				if (code !== 0) return;
				this.task_status = task_status;
				this.many_partner = many_partner;
				this.results_attribution = results_attribution;
				this.anchor_circulation_config = anchor_circulation_config;
				this.anchor_circulation_list = anchor_circulation_list.length
					? anchor_circulation_list
					: [
						{ key: 'claim_anchor', value: '0', day: '' },
						{ key: 'build_anchor', value: '0', day: '' },
						{ key: 'apply_anchor', value: '0', day: '' },
					];
				this.valid_type = valid_type;
				this.valid_time_value = valid_time?.value || orderPayOptMap.TWO;
				if (!this.task_status) this.getWaitFix();
			} catch (error) {
				console.error(error);
			} finally {
				this.loading = false;
			}
		},
		async getWaitFix() {
			const { platformId } = this;
			const { code, data = [] } = await getWaitFix({ platform_id: platformId });
			if (code !== 0) return;
			this.talentList = data;
		},
		showRuleExplainDialog(flag) {
			const { platformId } = this;
			this.$refs.ruleExplainDialog.show(flag, platformId);
		},
		arraySpanMethod({ columnIndex }) {
			if (columnIndex === 1) {
				return [1, 2];
			}
		},
		cellName({ columnIndex }) {
			if (columnIndex === 1) return 'special';
		},
		headerCellName({ columnIndex }) {
			if (columnIndex === 1) return 'header-special';
		},
		radioFun(list, index) {
			list.forEach((item, ind) => {
				if (index !== ind) {
					delete item['checked'];
				}
			});
		},
		cancel() {
			this.$refs.cancelDialog.show();
		},
		switchChange(row) {
			if (row.value == '0') row.day = '';
		},
		save: throttle(async function () {
			if (this.task_status) return;
			let { many_partner, anchor_circulation_config, anchor_circulation_list, results_attribution, isKsPlatform, platformId, drName } = this;
			let bind_list = [];
			if (!many_partner) {
				let state_list = [];
				this.talentList.forEach((item, index) => {
					item.partners.forEach((it, ind) => {
						if (it.checked) {
							bind_list.push({ anchor_id: item.anchor_id, user_id: it.user_id });
						}
					});
					let isChecked = item.partners.some(ite => ite.checked);
					state_list.push(isChecked);
					if (isChecked) {
						this.$set(this.talentList[index], 'checked', false);
					} else {
						this.$set(this.talentList[index], 'checked', true);
					}
				});
				if (state_list.indexOf(false) !== -1) return this.$message.error(`请选择${drName}`);
				if (anchor_circulation_config) {
					for (let i = 0, len = anchor_circulation_list.length; i < len; i++) {
						const item = anchor_circulation_list[i];
						if (item.value == '1' && !item.day) return this.$message.error('开启状态请设置规则内容');
					}
				}
			}
			anchor_circulation_list = anchor_circulation_list?.map(({ key, value, day }) => {
				let row = { key, value, day: +day, remark: '' };
				if (!anchor_circulation_config) row = { ...row, value: '0', day: 0 };
				return row;
			});
			let params = {
				results_attribution,
				platform_id: platformId,
				valid_type: this.valid_type,
				bind_list,
				many_partner,
				anchor_circulation_list,
				anchor_circulation_config,
			};
			if (this.showTimeSelect) {
				params.valid_time = {
					value: this.valid_time_value,
					dateField: 'M',
				};
			}
			console.log('params', params);
			await setPartnerToAnchor(params); //设置是否允许多个商务跟进多个达人达人
			this.$message.success('操作成功');
			this.back();
		}, 1000),
		back() {
			let { platformId } = this;
			this.$router.push({
				path: '/settings/newRuleManage/list',
				query: {
					platformId,
					type: 2,
				},
			});
		},
	},
};
</script>

<style lang="less" scoped>
/deep/ .el-input__inner {
	font-size: 14px !important;
}

.main-content {
	.left {
		width: 276px;
	}

	>.right {
		border: 1px solid #e2e3e8;
		border-radius: 8px;
		margin-left: 16px;
		padding: 24px;

		.rule-item {
			gap: 24px;

			.rule-title {
				width: 196px;
				font-family: PingFang SC;
				font-size: 14px;
				font-weight: 500;
				line-height: 22px;
				text-align: right;
				letter-spacing: 0em;

				font-variation-settings: 'opsz' auto;
				/* text/text-5-强调+正文标题 */
				color: #1d2129;

				>span {
					font-family: PingFang SC;
					font-size: 12px;
					font-weight: normal;
					line-height: 20px;
					letter-spacing: 0em;

					/* text/text-3-次要信息 */
					color: #86909c;
				}
			}

			.rule-content {
				.attribution_tab {
					font-family: PingFang SC;
					font-size: 14px;
					font-weight: 500;
					line-height: 22px;
					letter-spacing: 0em;

					font-variation-settings: 'opsz' auto;
					/* brand2/brand2-6 */
					border: 1px solid #e2e3e8;
					border-radius: 4px;
					padding: 8px 16px;

					&.attribution_tab_active {
						color: #2475ff;
						border: 1px solid #2475ff;
						background: #e9f1ff;
					}
				}
			}
		}
	}
}

.follow-item {
	gap: 6px;
	position: relative;
	width: 276px;
	box-sizing: border-box;
	height: 93px;
	border: 1px solid #e5e6eb;
	border-radius: 8px;

	.example {
		font-family: PingFang SC;
		font-size: 12px;
		font-weight: normal;
		line-height: 20px;
		letter-spacing: 0em;

		/* brand2/brand2-6 */
		color: #2475ff;
	}

	.flow-text {
		font-family: PingFang SC;
		font-size: 14px;
		font-weight: 500;
		line-height: 22px;
		letter-spacing: 0em;

		font-variation-settings: 'opsz' auto;
		/* text/text-5-强调+正文标题 */
		color: #1d2129;

		&.active {
			color: #2475ff;
		}
	}

	.i-select-corner {
		position: absolute;
		top: 0;
		right: 0;
	}
}

.rule-set {
	margin-top: 12px;
	color: #333;
	padding-bottom: 88px;

	.title {
		color: #333;
		font-weight: bold;

		.rule-explain {
			font-size: 14px;
			font-weight: 400;
			color: @color-primary;
			cursor: pointer;
		}
	}

	::v-deep .table-header-row th {
		background: #fff !important;
		border-right: none;
		border-bottom: 1px solid #e3e3e3 !important;
	}

	::v-deep .el-table__body-wrapper {
		max-height: 350px;
		overflow-y: auto;
	}

	.content {
		padding: 16px;
		background-color: #f9f9fa;
		border-radius: 4px;
	}

	.talent-info {
		display: flex;

		.right {
			margin-left: 8px;
			font-size: 12px;
			color: #666;
			line-height: 18px;
			flex: 1;
			overflow: hidden;

			.platform {
				flex-shrink: 0;
			}

			.ellipsis {
				color: #333;
				font-size: 14px;
			}
		}
	}

	.day-input {
		display: flex;
		align-items: center;
		white-space: nowrap;

		.el-input {
			width: 80px;
			margin: 0 6px;
		}
	}

	.flag {
		display: flex;
		align-items: center;

		&::before {
			content: '';
			width: 8px;
			height: 8px;
			border-radius: 50%;
			margin-right: 4px;
		}

		&.open::before {
			background-color: #0fb820;
		}

		&.close::before {
			background-color: #fa2d48;
		}
	}

	.partners {
		display: flex;
		justify-content: space-between;

		p {
			margin-left: 16px;
		}
	}

	.top {
		padding-bottom: 16px;
	}

	.middle {
		border-top: 1px solid #eeeeee;
		padding: 16px 0px;
	}

	.bottom {
		border-top: 1px solid #eeeeee;
		padding-top: 16px;
	}

	.label-radio {
		margin-right: 60px;
		display: flex;
		align-items: center;
	}

	.error {
		position: absolute;
		color: @color-danger;
	}

	::v-deep .special .cell {
		padding: 0px 0px !important;
	}

	::v-deep .header-special {
		border-right: 1px solid transparent !important;
	}

	.bottom-btn {
		width: 100%;
		position: fixed;
		bottom: 0;
		left: 0;
		background-color: #fff;
		text-align: center;
		padding: 16px 0;
		z-index: 9;
		border-top: 1px solid #eee;
		box-sizing: border-box;
	}
}
</style>
